const methodologies = [
  {
    title: "Clean Architecture",
    description:
      "Structuring codebases with clear separation of concerns, well-defined boundaries, and modular design patterns that enable independent development, testing, and long-term maintainability.",
    color: "bg-primary-100",
    iconColor: "text-primary-600",
  },
  {
    title: "Performance Optimization",
    description:
      "Systematic profiling, measurement, and tuning at every layer of the stack to ensure responsive, battery-efficient, and resource-conscious software that performs under real-world conditions.",
    color: "bg-accent-100",
    iconColor: "text-accent-600",
  },
  {
    title: "User-Centered Design",
    description:
      "Placing usability and accessibility at the center of every technical decision. We design interactions that feel intuitive, natural, and friction-free for the people who rely on our systems daily.",
    color: "bg-secondary-100",
    iconColor: "text-secondary-600",
  },
  {
    title: "Continuous Improvement",
    description:
      "Regular retrospectives, process refinement, and knowledge sharing ensure our workflows evolve alongside the technology. We treat every project as an opportunity to sharpen our craft.",
    color: "bg-primary-50",
    iconColor: "text-primary-500",
  },
  {
    title: "Modern Standards",
    description:
      "Adopting and contributing to current engineering best practices, coding conventions, and platform guidelines. We keep our tooling, dependencies, and methodologies aligned with the latest industry norms.",
    color: "bg-accent-50",
    iconColor: "text-accent-500",
  },
  {
    title: "Process Evolution",
    description:
      "Actively exploring new technologies and adapting internal processes to maintain high technical excellence. Our workflows are designed to be flexible, scalable, and responsive to change.",
    color: "bg-secondary-50",
    iconColor: "text-secondary-500",
  },
];

export default function MethodologySection() {
  return (
    <section className="relative bg-background-200/70 py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="mb-4">
          <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-300/40 bg-background-50 text-xs md:text-sm font-medium text-foreground-600 tracking-widest uppercase">
            How We Work
          </span>
        </div>
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-tight mb-14 md:mb-20">
          Engineering Methodology
          <br />
          <span className="font-normal italic text-foreground-600">
            &amp; Practices
          </span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {methodologies.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-2xl p-6 md:p-7 flex flex-col"
            >
              <div className="flex items-start gap-4 mb-4">
                <div
                  className={`w-12 h-12 md:w-14 md:h-14 rounded-full ${item.color} flex items-center justify-center flex-shrink-0`}
                >
                  <i className={`ri-code-line text-xl md:text-2xl ${item.iconColor}`}></i>
                </div>
                <div className="pt-1">
                  <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 leading-snug">
                    {item.title}
                  </h3>
                </div>
              </div>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed flex-1">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}